import { Observable, of, ReplaySubject } from 'rxjs';
import { AuthSessionService } from './auth-session.service';
import { SessionService } from '../../modules/administration/services/session.service';
import { LogService } from '../../modules/shared/services/log.service';
import { User } from '../../modules/administration/models/user';
import { Profiles } from '../../modules/administration/models/profiles';
import { Profile } from '../../modules/administration/models/profile';
import { EnumMicroDroits, MicroDroits } from '../../modules/administration/models/micro.droits';


/**
 * A fake AuthSessionService with mocked value, for local and unsecured environments
 */
export class MockSessionService implements AuthSessionService {

  private LOG: LogService = new LogService(MockSessionService);
  private profiles: Profiles;
  private _ready: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private session: SessionService) { }

  public setAccessTokenObject(accessToken: any): void {
    // no-op
  }

  public configure(): Observable<void> {
    this.profiles = this.mockProfiles();
    this._ready.next(true);
    return of(null);
  }

  /**
   * Create a new mock profiles
   */
  private mockProfiles(): Profiles {
    const user = new User();
    user.siret = '11111111111111';
    user.service = '11111111111111';
    user.raisonSociale = 'Gestionnaire avis et préférences';


    const microDroits = new MicroDroits();
    microDroits.microDroits = [
      EnumMicroDroits.COMPTES_ANNONCEURS_GESTION,
      EnumMicroDroits.DONNEES_FACTURATIONS_GESTION,
      EnumMicroDroits.AVIS_PUBLICITE_GESTION

    ]

    const profile: Profile = new Profile();
    profile.user = user;
    profile.microDroits = microDroits;


    const secondUser = new User();
    secondUser.siret = '11111111111111';
    secondUser.service = '22222222222222';
    secondUser.raisonSociale = 'Gestionnaire préférences';

    // profile AVIS_PUBLICITE_CONSULTER et GERER_PREFERENCE
    const secondUserMicroDroits = new MicroDroits();
    secondUserMicroDroits.microDroits = [
      EnumMicroDroits.AVIS_PUBLICITE_CONSULTATION,
      EnumMicroDroits.DONNEES_FACTURATIONS_GESTION,
      EnumMicroDroits.COMPTES_ANNONCEURS_GESTION
    ]

    const secondUserProfile: Profile = new Profile();
    secondUserProfile.user = secondUser;
    secondUserProfile.microDroits = secondUserMicroDroits;


    const thirdUser = new User();
    thirdUser.siret = '12345678901234';
    thirdUser.service = 'Acheteur';
    thirdUser.raisonSociale = 'Gestionnaire d\'avis';

    // profile AVIS_PUBLICITE_GERER
    const thirdUserMicroDroits = new MicroDroits();
    thirdUserMicroDroits.microDroits = [
      EnumMicroDroits.AVIS_PUBLICITE_GESTION,
    ]

    const thirdUserProfile: Profile = new Profile();
    thirdUserProfile.user = thirdUser;
    thirdUserProfile.microDroits = thirdUserMicroDroits;

    const fourthUser = new User();
    fourthUser.siret = '22222222222222';
    fourthUser.service = '22222222222222';
    fourthUser.raisonSociale = 'Consultation des préférences';

    // profile AVIS_PUBLICITE_PREFERENCES_CONSULTER 
    const fourthUserMicroDroits = new MicroDroits();
    fourthUserMicroDroits.microDroits = [
      EnumMicroDroits.DONNEES_FACTURATIONS_CONSULTATION,
      EnumMicroDroits.COMPTES_ANNONCEURS_CONSULTATION
    ]

    const fourthUserProfile: Profile = new Profile();
    fourthUserProfile.user = fourthUser;
    fourthUserProfile.microDroits = fourthUserMicroDroits;

    
    const fifthUser = new User();
    fifthUser.siret = '22222222222222';
    fifthUser.service = '11111111111111';
    fifthUser.raisonSociale = 'Gestion des avis et consultation des préférences';

    // profile AVIS_PUBLICITE_PREFERENCES_CONSULTER 
    const fifthUserMicroDroits = new MicroDroits();
    fifthUserMicroDroits.microDroits = [
      EnumMicroDroits.DONNEES_FACTURATIONS_CONSULTATION,
      EnumMicroDroits.COMPTES_ANNONCEURS_CONSULTATION,
      EnumMicroDroits.AVIS_PUBLICITE_GESTION
    ]

    const fifthUserProfile: Profile = new Profile();
    fifthUserProfile.user = fifthUser;
    fifthUserProfile.microDroits = fifthUserMicroDroits;



    const profiles: Profiles = new Profiles();
    profiles.profiles = [profile, secondUserProfile, thirdUserProfile, fourthUserProfile, fifthUserProfile];

    return profiles;
  }

  public getProfiles(): Observable<Profiles> {
    return of(this.profiles);
  }

  public getHeaders(): { [name: string]: string; } {
    return {
      'Authorization': 'Bearer toto',
      'access_token': 'accessToken',
      'siret': this.session.getUser()?.siret,
      'service': this.session.getUser()?.service
    };
  }

  public isReady(): Observable<boolean> {
    return this._ready.asObservable();
  }

  public logOut(): void {
    this.profiles = null;
  }

  isSwitchable(): Observable<boolean> {
    return of(true);
  }

  public logInfo(): void {
    this.LOG.info('======================[SESSION_INFO_BEGIN]=========================');
    this.LOG.info('[SESSION_TYPE]:', 'MOCK');
    this.LOG.info('This is a mocked authorization service')
    this.LOG.info('There is no meaningful information to display here')
    this.LOG.info('======================[SESSION_INFO_END]=========================')
  }
}
